/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  create(data) {
    if (data.files && data.files.length > 0) {
      const formData = new FormData();
      formData.append('canned_response[short_code]', data.short_code);
      formData.append('canned_response[content]', data.content || '');
      data.files.forEach(file => {
        formData.append('canned_response[files][]', file);
      });
      return axios.post(this.url, formData);
    }
    return axios.post(this.url, {
      canned_response: {
        short_code: data.short_code,
        content: data.content || '',
      },
    });
  }

  update(id, data) {
    const url = `${this.url}/${id}`;
    const hasNewFiles = data.files && data.files.length > 0;
    const hasRemovals = data.remove_file_ids && data.remove_file_ids.length > 0;

    if (hasNewFiles || hasRemovals) {
      const formData = new FormData();
      formData.append('canned_response[short_code]', data.short_code);
      formData.append('canned_response[content]', data.content || '');
      if (hasNewFiles) {
        data.files.forEach(file => {
          formData.append('canned_response[files][]', file);
        });
      }
      if (hasRemovals) {
        data.remove_file_ids.forEach(fileId => {
          formData.append('remove_file_ids[]', fileId);
        });
      }
      return axios.patch(url, formData);
    }

    return axios.patch(url, {
      canned_response: {
        short_code: data.short_code,
        content: data.content || '',
      },
    });
  }
}

export default new CannedResponse();
